import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Billboard from '../billboard/billboard';
import Contacts from '../contacts';
import Photos from '../photos/photos';
import PostsListing from '../posts/listing';
import SplitView from '../splitview';
import Text from '../text/text';
import Tiles from '../tiles/tiles';
import styles from './renderer.scss';

class SectionsRenderer extends Component {
  render() {
    const { sections } = this.props;

    if (sections === undefined) {
      return null;
    }

    const renderedSections = sections.map((section, index) => {

      if (section.sys.contentType === undefined) {
        return null;
      }

      const contentType = section.sys.contentType.sys.id;
      const key = section.sys.id + index;

      switch (contentType) {
        case 'billboard':
          return <Billboard key={key} {...section.fields}/>;
        case 'contacts':
          return <Contacts key={key} {...section.fields}/>
        case 'photos':
          return <Photos key={key} photos={section.fields.photos}/>;
        case 'postsListing':
          return <PostsListing key={key} id={key} query={section.fields.query} moreUrl={section.fields.moreUrl} moreLabel={section.fields.moreLabel} />
        case 'splitView':
          return <SplitView key={key} {...section.fields}/>;
        case 'text':
          return <Text key={key} {...section.fields}/>;
        case 'tiles':
          return <Tiles key={key} tiles={section.fields.tiles}/>
        default:
          return null;
      }
    });

    return (
      <main className={styles.renderer}>
        {renderedSections}
      </main>
    );
  }
}

SectionsRenderer.propTypes = {
  sections: PropTypes.array.isRequired
}

export default SectionsRenderer;



// WEBPACK FOOTER //
// ./src/components/sections/renderer.jsx